import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import upperfirst from 'lodash.upperfirst';
import { Link } from 'react-router-dom';
import { NavigateNextIcon } from 'components/StyledIcons/StyledIcons';
import { sendEvent } from 'utils/gtag';
import styled from 'styled-components';

const Root = styled.div`
  &&& {
    nav {
      color: rgba(0, 0, 0, 0.54);
      font-size: 1rem;
      font-family: "Roboto", "Helvetica", "Arial", sans-serif;
      font-weight: 400;
      line-height: 1.5;
      letter-spacing: 0.00938em;
    }
    ol {
      margin: 0!important;
      display: flex!important;
      padding: 0!important;
      flexWrap: wrap!important;
      alignItems: center!important;
    }
    li {
      list-style: none!important;
    }
    .breadcrumb-separator {
      display: flex!important;
      user-select: none!important;
      margin: 0 0.5rem!important;
      align-items: center!important;
    }
  }
`;

const BreadcrumbEl = ({ countryName = '', cityName = '' }) => {
  const iconStyle = useMemo(() => ({ root: { margin: '0 -4px' } }), []);

  return (
    <Root>
      <nav aria-label="breadcrumb">
        <ol>
          <Link
            to="/"
            onClick={e => {
              e.stopPropagation();
              sendEvent({ action: 'Click Breadcrumb', category: 'navigation', label: '/' });
            }}
          >
            Home
          </Link>
          <li className="breadcrumb-separator" aria-hidden="true">
            <NavigateNextIcon fontSize="small" key="NavigateNextIcon" overwritestyles={iconStyle} aria-hidden="true" />
          </li>
          <Link
            to={`/country/${countryName.toLowerCase()}`}
            onClick={e => {
              e.stopPropagation();
              sendEvent({ action: 'Click Breadcrumb', category: 'navigation', label: `/country/${countryName.toLowerCase()}` });
            }}
          >
            { upperfirst(countryName) }
          </Link>
          <li className="breadcrumb-separator" aria-hidden="true">
            <NavigateNextIcon fontSize="small" key="NavigateNextIcon" overwritestyles={iconStyle} aria-hidden="true" />
          </li>
          <Link
            to={`/search/${cityName.toLowerCase()}`}
            onClick={e => {
              e.stopPropagation();
              sendEvent({ action: 'Click Breadcrumb', category: 'navigation', label: `/search/${cityName.toLowerCase()}` });
            }}
          >
            { upperfirst(cityName) }
          </Link>
          <li className="breadcrumb-separator" aria-hidden="true">
            <NavigateNextIcon fontSize="small" key="NavigateNextIcon" overwritestyles={iconStyle} aria-hidden="true" />
          </li>
          <Link
            to={`/search?cities=${cityName.toLowerCase()}`}
            onClick={e => {
              e.stopPropagation();
              sendEvent({ action: 'Click Breadcrumb', category: 'navigation', label: `/search/?cities=${cityName.toLowerCase()}` });
            }}
          >
            Itineraries
          </Link>
        </ol>
      </nav>
    </Root>
  );
};

BreadcrumbEl.propTypes = {
  countryName: PropTypes.string,
  cityName: PropTypes.string,
};

BreadcrumbEl.defaultProps = {
  countryName: '',
  cityName: '',
};

export default BreadcrumbEl;
